import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.parse-float";
import "core-js/modules/es.promise";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import shallow from 'zustand/shallow';
import useStore from './../store';
import { getRoundedValue, useDebounce } from './../utils';
import { schools } from './../../../../data/schools';
import { CPAL_METRICS, CPAL_FEEDERS } from './../../../../constants/metrics';
import { BOUNDS, DEFAULT_ROUTE } from './../../../../constants/map';
import { CPAL_LAYERS } from './../../../../constants/layers';
/**
 * Get a route parameters object based on the string
 * @param {string} path
 * @returns {object} e.g. { region: 'counties', metric: 'avg', ... }
 */

export var getParamsFromPathname = function getParamsFromPathname(path, routeVars) {
  // console.log('getParamsFromPathname()')
  // strip starting "#" and "/" chars
  var route = path.replace(/^#\/+/g, ''); // Construct object from hash

  return route.split('/').reduce(function (acc, curr, i) {
    var _extends2;

    return _extends({}, acc, (_extends2 = {}, _extends2[routeVars[i]] = ['zoom', 'lat', 'lon'].indexOf(routeVars[i]) > -1 ? parseFloat(curr) : curr, _extends2));
  }, {});
};
export var getStrippedRoute = function getStrippedRoute(route) {
  return route.replace(/^#[/]+/g, '').replace(/\/$/g, '');
};
export var isEmptyRoute = function isEmptyRoute(route) {
  return getStrippedRoute(route).length === 0;
};
/**
 * Verify that view contains one of the two views.
 * @param  String view View string
 * @return Boolean
 */

var isViewValid = function isViewValid(view) {
  // console.log('isViewValid')
  return ['feeder', 'map'].indexOf(view) > -1;
};
/**
 * Verifies that metric exists in metric collection.
 * @param  {String}  metric String that corresponds to metric ID in constants
 * @return {Boolean}
 */


var isMetricValid = function isMetricValid(metric) {
  // Check if it's in the metrics list
  // console.log('isMetricValid')
  // If it's empty, just return true. We'll use the default.
  if (metric.length === 0) {
    return true;
  } else {
    // If not empty, verify that it's in the metrics collection.
    var filter = CPAL_METRICS.find(function (el) {
      return el.id === metric;
    });
    return !!filter ? true : false;
  }
};
/**
 * Verifies that quintiles string can be converted into array of quintiles.
 * @param  {String}  quintiles String of comma-separated numbers
 * @return {Boolean}
 */


var isQuintilesValid = function isQuintilesValid(quintiles) {
  // console.log('isQuintilesValid')
  if (!quintiles) return true;
  if (quintiles.length < 5) return false;
  var arr = quintiles.split(',');
  var t = true;
  arr.forEach(function (el) {
    var n = Number(el);

    if (n !== 1 && n !== 0) {
      t = false;
    }
  });
  return t;
};

var isFeederValid = function isFeederValid(feeder) {
  // console.log('isFeederValid()')
  if (!feeder || feeder.length === 0) {
    return true;
  } else {
    // If not empty, verify that it's in the feeders collection.
    var filter = CPAL_FEEDERS.find(function (el) {
      return Number(el.id) === Number(feeder);
    });
    return !!filter ? true : false;
  }
};

var isSchoolValid = function isSchoolValid(school) {
  // console.log('isSchoolValid()')
  if (!school || school.length === 0) {
    return true;
  } else {
    // If not empty, verify that it's in the feeders collection.
    var filter = schools.find(function (el) {
      return Number(el.SLN) === Number(school);
    });
    return !!filter ? true : false;
  }
};

var isLayersValid = function isLayersValid(layers) {
  // console.log('isLayersValid()')
  if (!layers) return true;
  var arr = layers.split(','); // console.log('arr, ', arr)

  if (arr.length !== 7) return false;
  var t = true;
  arr.forEach(function (el, i) {
    var n = Number(el);

    if (n !== 1 && n !== 0) {
      t = false;
    }

    if (CPAL_LAYERS[i].only_one === true && Number(arr[i]) === 1) {
      // Get the name
      var name = CPAL_LAYERS[i].only_one_name; // If others with same name are true in layers, return false.
      // console.log('only one loop, others = ', others)

      CPAL_LAYERS.forEach(function (item, index) {
        if (i !== index && item.only_one === true && item.only_one_name === name) {
          // console.log('matching up the other only-ones')
          if (Number(arr[index]) === 1) {
            // console.log("there's another true")
            t = false;
          }
        }
      });
    }
  }); // console.log('isLayersValid(), ', t)

  return t;
};

var isLatLngValid = function isLatLngValid(lat, lng) {
  // console.log('isLatLngValid()')
  // Make sure they're inside the bounds.
  if (!lat && !lng) return true;
  lat = Number(lat);
  lng = Number(lng);
  var isValid = true;

  if (lat < BOUNDS.lat.min || lat > BOUNDS.lat.max) {
    // console.log('lat out of bounds')
    isValid = false;
  }

  if (lng < BOUNDS.lng.min || lng > BOUNDS.lng.max) {
    // console.log('lng out of bounds')
    isValid = false;
  }

  return isValid;
};

var isZoomValid = function isZoomValid(zoom) {
  // console.log('isZoomValid, ', zoom)
  if (!zoom) return true; // Make sure it's within the zoom min and max.

  return zoom > BOUNDS.zoom.min && zoom < BOUNDS.zoom.max;
};
/**
 * Validates all route params
 * @param  {Object}  params [description]
 * @return {Boolean}        [description]
 */


var isRouteValid = function isRouteValid(params) {
  // console.log('isRouteValid(), ', params)
  var isValid = true;

  if (!isViewValid(params.view) || !isMetricValid(params.metric) || !isQuintilesValid(params.quintiles) || !isFeederValid(params.feeder) || !isSchoolValid(params.school) || !isLayersValid(params.layers) || !isLatLngValid(params.lat, params.lng) || !isZoomValid(params.zoom)) {
    isValid = false;
  }

  console.log('hash is valid = ', isValid);
  return isValid;
};
/**
 * Constructs a comma-delineated string from array of active layers.
 * @param  {Array} activeLayers
 * @return {String}
 */


var getLayersString = function getLayersString(activeLayers) {
  // console.log('getLayersString(), ', activeLayers)
  return activeLayers.toString();
};

var RouteManager = function RouteManager(props) {
  // track if initial route has loaded
  var isLoaded = useRef(false); // Generic store value setter.

  var setStoreValues = useStore(function (state) {
    return state.setStoreValues;
  }); // Active view.

  var activeView = useStore(function (state) {
    return state.activeView;
  }); // Update view select control

  var viewSelect = useStore(function (state) {
    return state.viewSelect;
  }); // Active metric.

  var activeMetric = useStore(function (state) {
    return state.activeMetric;
  }); // Active standard deviations.

  var activeQuintiles = useStore(function (state) {
    return state.activeQuintiles;
  }); // Active feeder.

  var activeFeeder = useStore(function (state) {
    return state.activeFeeder;
  }); // Highlighted school.

  var highlightedSchool = useStore(function (state) {
    return state.highlightedSchool;
  }); // Active layers.

  var activeLayers = useStore(function (state) {
    return [].concat(state.activeLayers);
  }, shallow); // Viewport.

  var viewport = useStore(function (state) {
    return state.viewport;
  });
  var setViewport = useStore(function (state) {
    return state.setViewport;
  }); // Feeder is locked.

  var feederLocked = useStore(function (state) {
    return state.feederLocked;
  }); // Track share hash and update when it changes

  var shareHash = useStore(function (state) {
    return state.shareHash;
  });
  /**
   * Returns a hash based on state
   * @return {String} [description]
   */

  var getHashFromState = function getHashFromState() {
    var hash = activeView + '/' + activeMetric + '/' + activeQuintiles.toString() + '/' + (!!activeFeeder && !!feederLocked ? activeFeeder : '') + '/' + (!!highlightedSchool && !!feederLocked ? highlightedSchool : '') + '/' + getLayersString(activeLayers) + '/' + getRoundedValue(viewport.latitude, 4) + '/' + getRoundedValue(viewport.longitude, 4) + '/' + getRoundedValue(viewport.zoom, 2) + '/';
    return hash;
  }; // get the route params based on current view


  var route = getHashFromState(); // debounce the route so it updates every 1 second max

  var debouncedRoute = useDebounce(route, 500);
  /**
   * Sets state from route params
   * @param {[type]} params [description]
   */

  var setStateFromHash = function setStateFromHash(params) {
    // console.log('setStateFromHash()')
    if (!!params.view) {
      // setActiveView(params.view)
      var newViewSelect = viewSelect.map(function (el) {
        if (String(el.id).indexOf(params.view) >= 0) {
          el.active = true;
        } else {
          el.active = false;
        }

        return el;
      });
      setStoreValues({
        activeView: params.view,
        viewSelect: newViewSelect
      });
    }

    if (!!params.metric) {
      setStoreValues({
        activeMetric: params.metric
      });
      var tab = CPAL_METRICS.filter(function (el) {
        return el.id === params.metric;
      })[0].tab;

      if (!!tab) {
        setStoreValues({
          activeFilterTab: tab
        });
      } // console.log('setting metric, ', params.metric, tab)

    }

    if (params.quintiles && params.quintiles.length > 0) {
      var quintiles = params.quintiles.split(',');
      setStoreValues({
        activeQuintiles: quintiles.map(function (el) {
          return Number(el);
        })
      });
    }

    if (!!params.feeder) {
      setStoreValues({
        activeFeeder: params.feeder,
        feederLocked: true
      });
    }

    if (!!params.school) {
      setStoreValues({
        highlightedSchool: params.school,
        feederLocked: true
      });
    }

    if (params.layers && params.layers.length > 0) {
      var getLayers = params.layers.split(',');
      setStoreValues({
        activeLayers: getLayers.map(function (el) {
          return Number(el);
        })
      });
    }

    var resetViewport = false;

    if (!!params.lat && !!params.lng) {
      viewport.latitude = Number(params.lat);
      viewport.longitude = Number(params.lng);
      resetViewport = true;
    }

    if (!!params.zoom) {
      viewport.zoom = Number(params.zoom);
      resetViewport = true;
    }

    if (!!resetViewport) {
      setViewport(viewport);
    }
  };

  useEffect(function () {
    if (isLoaded.current) {
      // When hash changes, if route is valid, update route for sharing.
      window.addEventListener('hashchange', function () {
        // console.log('hashchange')
        var path = window.location.hash; // Construct params object from hash.

        var params = getParamsFromPathname(path, props.routeSet);

        if (!isEmptyRoute(path) && isRouteValid(params, props.routeSet) && path !== shareHash) {
          // console.log('updating hash')
          setStoreValues({
            shareHash: window.location.hash
          });
        }
      });
    }
  }, [isLoaded.current]); // update the hash when debounced route changes

  useEffect(function () {
    // only change the hash if the initial route has loaded
    if (isLoaded.current) {
      // window.location.hash = '#/' + debouncedRoute
      window.history.replaceState({
        hash: '#/' + debouncedRoute
      }, 'Explorer state update', window.location.origin + window.location.pathname + '#/' + debouncedRoute);
      localStorage.setItem('cpal_hash', '#/' + debouncedRoute);
      setStoreValues({
        shareHash: '#/' + debouncedRoute
      });
    }
  }, [debouncedRoute]); // load the route when the application mounts

  useEffect(function () {
    function loadRoute() {
      return _loadRoute.apply(this, arguments);
    }

    function _loadRoute() {
      _loadRoute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var path, params, localStorageHash, lsparams;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // console.log('loadRoute')
                isLoaded.current = true; // Get path.

                path = window.location.hash; // Construct params object from hash.

                params = getParamsFromPathname(path, props.routeSet);
                localStorageHash = localStorage.getItem('cpal_hash');

                if (!isEmptyRoute(path) && isRouteValid(params, props.routeSet)) {
                  // Update state based on params
                  setStateFromHash(params);
                } else if (!!localStorageHash) {
                  if (localStorageHash.length > 0) {
                    lsparams = getParamsFromPathname(localStorageHash, props.routeSet);

                    if (isRouteValid(lsparams, props.routeSet)) {
                      setStateFromHash(lsparams);
                    }
                  }
                }

                if (isEmptyRoute(path) && !localStorageHash) {
                  // console.log('showing intro modal')
                  setStoreValues({
                    showIntroModal: true
                  });
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _loadRoute.apply(this, arguments);
    }

    loadRoute(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // this component doesn't render anything

  return null;
};

RouteManager.propTypes = {
  routeSet: PropTypes.array // Constants listing params and allowable options.

};
export default RouteManager;